module.exports = __webpack_public_path__ + "img/user.fa173d62.svg";